import useIsBrowser from 'hooks/useIsBrowser';

// Please note: when possible it is preferred that responsive width-based
// conditional checks such as the isMobile function are used, but in rare cases
// where we need to check for mobile user agents we can use this hook.
const useIsMobileUserAgent = () => {
  const isBrowser = useIsBrowser();

  // Always return false until the component has mounted in the browser, to
  // prevent SSR hydration errors
  if (
    isBrowser &&
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator && navigator.userAgent
    )
  ) {
    return true;
  }

  return false;
};

export default useIsMobileUserAgent;
